let defaultConfig = {
    jwtTemplate: 'jwt_lotfits',
    oryBasePath: 'http://localhost:4000',
    tenantId: '',
    loginRedirectLocal: '/unauthorized', // leave empty if app is not embedded, so it redirects to login page
};

let globalConfig = {
    appRoot: process.env.VUE_APP_ROOT,
    appBase: process.env.VUE_APP_BASE,
    identityApi: process.env.VUE_APP_IDENTITY_API,
    apiUrl: process.env.VUE_APP_API_URL,
    useJwt: process.env.VUE_APP_USE_JWT,
    applicationName: process.env.VUE_APP_CLIENT_ID,
    jwtTemplate: process.env.VUE_APP_JWT_TEMPLATE,
    oryBasePath: process.env.VUE_APP_ORY_BASE_PATH,
};

let preparedConfig = Object.assign(defaultConfig, globalConfig);

export function initConfig() {
    let tenantId = getTenantId();
    if (tenantId) {
        sessionStorage.setItem('tenantId', tenantId);
    }
}

export function getTenantId() {
    let tenantId = sessionStorage.getItem('tenantId');
    if (tenantId)
        return tenantId;
    if (preparedConfig.tenantId)
        return preparedConfig.tenantId;
    let urlParams = new URLSearchParams(window.location.search);
    tenantId = urlParams.get('tenantId');
    return tenantId || '';
}

export default preparedConfig